export default __webpack_public_path__ + "media/Agents_hero_left_desktop.2ce6de07119394b69a035849637d6e17.svg";